import React from "react";
import TextInput from "../../../core/form/TextInput";
import {useFormContext} from 'react-hook-form'

let AddressCityField = ({loading = false, disabled = false}) => {

    let {watch} = useFormContext()

    let customAddress = watch('use_custom_address')

    return <TextInput
        name='address.city'
        namePrefix='address'
        label='form.address.city'
        required={true}
        loading={loading}
        disabled={disabled || customAddress === false}
    />

}

export default AddressCityField